<div class="how_to_body">
  <slot />
</div>

<style>
  .how_to_body {
    margin: 0 2.5rem 1rem 2.5rem;
    font-size: 0.95rem;
  }
</style>
